<template>
  <b-card>
    <div>
      <b-row>
        <b-col cols="12" md="12">
          <div>Permission Assigned to Role</div>
          <br />
        </b-col>
        <b-col cols="12">
          <b-form-group
            label=""
            v-slot="{ ariaDescribedby }"
            class="modify_checkbox"
          >
            <b-form-checkbox-group>
              <b-form-checkbox
                v-for="option in permessionNames"
                v-model="permissionForm.permissionsIds"
                :key="option.value"
                :value="option.value"
                :aria-describedby="ariaDescribedby"
                name="flavour-3a"
              >
                {{ option.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <br />
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button variant="primary" @click="modifyPermissions()">
            Submit
          </b-button>
        </b-col>
      </b-row>
    </div>
    <!-- <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner label="Loading..." />
        </div>
      </div>
    </template> -->
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BSpinner,
  VBModal,
  BFormCheckboxGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BSpinner,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
  },
  data() {
    return {
      loading: true,
      page: 1,
      take: 10,
      totalInvoices: 0,
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      totalRows: "",
      sortBy: "id",
      isSortDirDesc: true,
      statusFilter: null,
      addForm: {
        name: "",
      },
      params: {
        form: {},
        path: "",
      },
      permissionForm: {
        permissionsIds: [],
      },
      permessionList: [],
      permessionNames: [],
      removedPermessionIdList: {
        permissionIds: [],
      },
      permessionIdList: [],
    };
  },
  mounted() {
    this.getPermissions();
    // this.getPermissions();
  },
  methods: {
    async index() {
      await this.getList(`/permissions/user/${router.currentRoute.params.id}`);
      this.permessionList = this.all_data;
      this.all_data.forEach((item) => {
        const foundItem = this.permessionNames.find((x) => x.text === item);
        this.permissionForm.permissionsIds.push(foundItem.value);
        this.permessionIdList.push(foundItem.value);
      });
    },
    async getPermissions() {
      await this.getList(`/permission?take=1000`);
      this.all_data.data.forEach((item) => {
        this.permessionNames.push({
          value: item.id,
          text: item.name,
        });
      });
      if (this.permessionNames.length) {
        this.index();
        this.loading = false;
      }
    },
    modifyPermissions() {
      this.permessionIdList.forEach((item) => {
        if (!this.permissionForm.permissionsIds.includes(item)) {
          this.removedPermessionIdList.permissionIds.push(item);
        }
      });
      this.assignPermissionsToUser();
    },

    assignPermissionsToUser() {
      this.permissionForm.permissionIds =
        this.permissionForm.permissionsIds.filter((x) => x != null);
      (this.params.form = this.permissionForm),
        (this.params.path = `/give-permissions-to/user/${router.currentRoute.params.id}`),
        this.$store
          .dispatch("create", this.params)
          .then(() => {
            this.$router.push({
              name: "users",
            });
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Permissions Assigned to Role was Updated",
                icon: "InfoIcon",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>

<style scoped>
.modify_checkbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: 30px;
  column-gap: 5px;
}

.custom-checkbox {
  width: 18rem;
  height: 3rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
